module.exports = __webpack_public_path__ + "static/media/road.865db075.svg";